<template>
  <div style="margin: 0 48px 8px 24px;">
    <el-form ref="formRef" :model="imgForm" label-width="auto" label-position="right">
      <el-form-item label="示例图：">
        <div>
          <div class="img-box" v-if="src">
            <el-image style="width: 80px; height: 80px; cursor: pointer" fit="cover"  :src="src" @click="headImgUpdate"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            <div class="delIcon" @click="showImg(src)"><ElIcons name="View" color="#ffffff"></ElIcons></div>
          </div>

          <div class="add" @click="headImgUpdate" v-else>
            <span>+</span>
          </div>
          <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
        </div>
      </el-form-item>
      <el-form-item label="排序：">
        <el-input v-model="imgForm.orderNum" placeholder="数字越大越靠前" :maxlength="11"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin-top: 24px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" :disabled="loading" v-loading="loading" >确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData, imgPostFormData } from "@/api/api"
import { addOrUpdateStandardImg} from "@/api/url";
import { phoneReg, greaterIntReg } from "@/assets/shared/reg-constant";
import * as imageConversion from 'image-conversion'
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "BannerDialog",
  props: {
    value: Object
  },
  data() {
    return {
      imgForm: this.value.imgForm,
      hygieneStandardId: this.value.hygieneStandardId,
      idx: this.value.ids,

      files: null,
      src: this.value.imgForm.img,

      loading: false
    }
  },
  methods: {

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList,
        imgIndex: 0
      })
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        // this.beforeAvatarUpload(e.target.files[0]).then(res => {
        //   console.log(res)
        //   this.files = res
        //   imageConversion.filetoDataURL(this.files).then(url => {
        //     this.src = url
        //   })
        // })
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    //压缩到指定大小
    beforeAvatarUpload(file) {
      // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJpgOrPng) {
      //   //自己封装的错误提示方法
      //   // this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '上传图片只能是 JPG 或 PNG 格式!',
      //     type: 'warning'
      //   });
      // }
      // // if (!isLt2M) {
      // //   this.$message.error('上传图片大小不能超过 2MB!');
      // // }
      // if (!isLt2M || !isJpgOrPng) {
      //   return false;
      // }
      return new Promise((resolve) => {
        // 压缩到100KB,这里的100就是要压缩的大小,可自定义 //质量为0.6进行压缩
        imageConversion.compressAccurately(file, 200).then(res => {
          resolve(res);
        });
      })
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(!this.imgForm.files && !this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '示例图图片不能为空',
          type: 'warning'
        });
        return false
      }
      if(!greaterIntReg.test(this.imgForm.orderNum)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '排序不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let param = new FormData();
      param.append('id', this.idx > -1?this.imgForm.id:0);
      param.append('hygieneStandardId', this.hygieneStandardId);
      param.append('orderNum', this.imgForm.orderNum);
      param.append('file', this.files);

      imgPostFormData(addOrUpdateStandardImg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.loading = false
      })
    },


  },
  mounted() {

  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  margin: 0 auto
}

.delIcon {
  background-color: rgba(0,0,0,0.8);
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.img-box {
  width: 80px;
  height: 80px;
  position: relative;
}

</style>
